export const tasksGroups = {
  flexduty: [
    'FlexPortalMatchNotifyPlanner',
    'DutyLineUnlinkNotificationNotifyPlanner',
    'FlexPortalMatchNotifyPlannersRejectTask'
  ],
  dutyMutationEmployee: [
    'AgendaDutyLineCreateManagerApprove',
    'AgendaDutyLineEditManagerApprove'
  ],
  dutyMutationPlanner: [
    'RosterDutyLineCreateManagerApprove',
    'RosterDutyLineEditManagerApprove'
  ],
  dutyRejectedManager: [
    'RosterDutyLineCreateNotifyPlannerRejected',
    'RosterDutyLineEditNotifyPlannerRejected'
  ],
  leaveRequests: ['LeaveRequestCreateTask', 'LeaveRequestAfterSeenTask'],
  employments: ['expiringEmploymentContracts', 'endOfEmploymentsSettlements'],
  dayLimitViolations: ['dayLimitViolations'],
  additionalCompensations: ['additionalCompensations']
};

export const iconsMapping = {
  flexduty: 'link',
  dutyMutationEmployee: 'calendar-day',
  dutyMutationPlanner: 'calendar-day',
  dutyRejectedManager: 'calendar-day',
  leaveRequests: 'tree-palm',
  travelExpenseClaims: 'route',
  employments: 'file-contract',
  dayLimitViolations: 'calendar-day',
  additionalCompensations: 'calendar-day'
};
